import { gql } from '@apollo/client';

export const PAYMENT_METHOD_FRAGMENT = gql`
  fragment PaymentMethodData on PaymentMethod {
    id
    source
    lastFour
    type
    hasSuccessfulTransactions
  }
`;

export const FETCH_EXISTING_PAYMENT_METHODS = gql`
  query Flex_FetchExistingPaymentMethods($accountId: Int!) {
    account(id: $accountId) {
      paymentMethods {
        ...PaymentMethodData
      }
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
`;
